import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as textMetrics from 'text-metrics/dist';
import { BaseBlockView } from '../base-block.view';
import { JobadListModel } from '../../../model/block';
import styled from 'styled-components';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { findLinkedData } from '../../../util/page/find-linked-data.util';
import { ColorEnum, ColorType } from '../../../enum/color.enum';
import { ISingleJobadItemData, JobadListLinkedDataModel } from '../../../model/linked-data';
import { DesignObjectMentionMetadataType } from '../../../enum/page-mention-metadata-type.enum';
import { LinkedDataModel } from '../../../model/linked-data/linked-data.model';
import * as moment from 'moment';
import {action, computed, observable, toJS} from 'mobx';
import { ISelectedTag, SEARCH_ELEMENTS_HEIGHT, Tag, TAG_HORIZONTAL_MARGIN, TAG_HORIZONTAL_PADDING, TagSearch } from './tag-search/tag-search';
import { AjaxResponse } from 'rxjs/observable/dom/AjaxObservable';
import { MentionFilterTypeEnum } from '../../../enum/mention-filter-type.enum';
import { DraftToHtml } from '../../draft-to-html/draft-to-html';
import { isDraftEmpty } from '../../../util/draft/is-draft-empty.util';
import { draftToString } from '../../../util/draft/draft-to-string.util';
import { findIndex } from 'lodash';
import { JobadCard, maxJobadCardsWidthPerPage } from './jobad/jobad-card';
import { Jobad } from './jobad/jobad';
import { CATEGORY_CLASS_NAMES, LARGE_SCREEN_SIZE, LOCATION_CLASS_NAMES } from '../../../constants';
import { BlockColorType } from '../../../enum/block-color.enum';
import Translate from '../../translate/translate';
import { isStringEmpty } from '../../../util/string/is-string-empty.util';
import { MinusIcon, PinIcon, PlusIcon, SearchIcon } from '../../icons';
import { regExpEscape } from '../../../util/string/reg-exp-escape.util';
import { Snippet } from '../../snippet/snippet';
import { SchemaORG } from '../../../interface/schema.org';
import { formLinkFromTemplate } from '../../../util/url/form-link-from-template';
import { getLinkFinalURL } from '../../../util/url/get-link-final-url';
import { joinUrl } from '../../../util/url/join-url.util';
import { CmsButton } from '../../cms-button/cms-button';
import { JobadViewStyleEnum } from '../../../enum/block/jobad-view-style.enum';
import { FilterValueTypes, IFilter } from '../../../interface/page/mention-filter.interface';
import { resolveLinkedData } from '../../../util/action/type/get-linked-data-with-filter-action.util';
import { IFilterGroupsHolder } from '../../../interface/page/design-object-mention-metadata.interface';
import { LinkedDataErrorCodes } from '../../../interface/linked-data-error.interface';
import { ErrorWrapper } from '../../atoms';

export const LETTER_WIDTH = 9;
const TAG_HEIGHT = 35;
const TAG_VERTICAL_PADDING = 5;
const CARD_LAYOUT_HORIZONTAL_PADDING = 20;
const TAGS_CONTAINER_HEIGHT = 2 * TAG_HEIGHT + 4 * TAG_VERTICAL_PADDING;

interface IJobadListWrapperProps {
  isCardLayout: boolean;
}

const JobadListWrapper = styled.div<IJobadListWrapperProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 25px ${(props: IJobadListWrapperProps) => props.isCardLayout ? CARD_LAYOUT_HORIZONTAL_PADDING : 0}px;
  margin: auto;
  ${(props: IJobadListWrapperProps) => props.isCardLayout ? `max-width: ${maxJobadCardsWidthPerPage() + 2 * CARD_LAYOUT_HORIZONTAL_PADDING}px;` : getCenterOfPageStyle()}
`;

const SearchComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 21px;
`;

const HeaderTextWrapper = styled.div`
  width: 100%;
  text-align: center;
  font-size: 30px;
  margin-bottom: 21px;
  color: ${props => ColorEnum.getColor('PrimaryTextColor')(props as any)};
`;

const TagsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Tags = styled.div`
  width: 100%;
  position: relative;
`;

interface ITagsContainerProps {
  shouldSplit: boolean;
  shouldGrow: boolean;
}

const TagsContainer = styled.div<ITagsContainerProps>`
  width: ${(props) => props.shouldSplit ? 50 : 100}%;
  height: ${(props) => props.shouldGrow ? 'auto' : `; max-height: ${TAGS_CONTAINER_HEIGHT}px`};
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const AllTagsSearch = styled.div`
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  background-color: ${ColorEnum.White};
  border-radius: 100px;
  margin: 30px 0;
  @media (min-width: ${LARGE_SCREEN_SIZE}px) {
    display: none;
  }
`;

const SplitTagsSearch = styled.div`
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  background-color: ${ColorEnum.White};
  border-radius: 100px;
  margin: 30px 0;
  @media (max-width: ${LARGE_SCREEN_SIZE}px) {
    display: none;
  }
`;

const SearchContainer = styled.div`
  width: 100%;
  display: flex;
`;

const SearchSeparator = styled.div<{ backgroundColor: BlockColorType }>`
  width: 4px;
  background-color: ${(props) => ColorEnum.getColor(props.backgroundColor)(props as any)};
  height: ${SEARCH_ELEMENTS_HEIGHT}px;
`;

const TagsGroupSeparator = styled.div`
  width: 100%;
  background-color: ${(props: { backgroundColor: BlockColorType }) => ColorEnum.getColor(props.backgroundColor)(props as any)};
  height: 2px;
`;

const StyledSearch = styled(SearchIcon)`
  color: ${(props: { color: ColorType }) => ColorEnum.getColor(props.color)(props as any)};
  margin: 11px;
  min-width: 24px;
  min-height: 24px;
` as any;

const StyledMinus = styled(MinusIcon)`
  width: 15px;
  height: 15px;
  padding-right: 5px;
`;

const StyledPlus = styled(PlusIcon)`
  width: 15px;
  height: 15px;
  padding-right: 5px;
`;

const StyledPin = styled(PinIcon)`
  color: ${(props: { color: ColorType }) => ColorEnum.getColor(props.color)(props as any)};
  margin: 11px;
  min-width: 24px;
  min-height: 24px;
` as any;

const ShowMoreJobadsButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 46px;
`;

function isJobadData(data: LinkedDataModel): data is JobadListLinkedDataModel {
  return data && data.type === DesignObjectMentionMetadataType.JobAdList;
}

enum TagListEnum {
  LOCATION = 'LOCATION',
  CATEGORY = 'CATEGORY',
  ALL = 'ALL'
}

function createTagFromText(label: string, disabled: boolean = false) {
  return {
    label,
    disabled
  };
}

@inject('state', 'history', 'dispatch', 'service')
@observer
export class JobadListView extends BaseBlockView<JobadListModel, IInjectedProps> {
  @observable selectedLocationTags: ISelectedTag[] = [];
  @observable selectedCategoryTags: ISelectedTag[] = [];
  @observable categories = [];
  @observable locations = [];
  @observable showAllCategoryTags = false;
  @observable showAllLocationTags = false;
  @observable selectedTagsTab = TagListEnum.CATEGORY;
  @observable mounted: boolean = false;
  @observable loadingMoreJobads: boolean = false;
  @observable tagsContainerWidth = 0;
  originalFilters: IFilterGroupsHolder;
  tag;
  tagsContainer;
  metrics;

  @computed
  get shouldSplit() {
    if (!this.mounted) {
      return true;
    }
    return this.props.state.windowSize.width > LARGE_SCREEN_SIZE;
  }

  renderJobadList = (listData: ISingleJobadItemData[]) => {
    if (!listData || listData.length === 0) {
      return <span>{draftToString(this.linkedData && this.linkedData.initialAsyncData && this.linkedData.pagedProperties.page === 0 ? this.props.content.loadingMessage : this.props.content.noResultsMessage, this.props.state)}</span>;
    }
    const jobAds = [];
    const numberOfJobadsToRender = this.shouldRenderShowMoreJobadsButton && this.linkedData && !this.linkedData.pagedProperties && this.props.content.jobadLimit <= listData.length ? this.props.content.jobadLimit : listData.length;
    const JobadItem = this.props.content.jobadViewStyle === JobadViewStyleEnum.CARD ? JobadCard : Jobad;
    for (let i = 0; i < numberOfJobadsToRender; i++) {
      jobAds.push(<JobadItem
        hasShadow={this.props.content.useShadows}
        jobadBackgroundColor={this.props.content.jobadBackgroundColor}
        jobadTagTextColor={this.props.content.jobadTagTextColor}
        jobad={this.props.content}
        applyBeforeBackgroundColor={this.props.content.tagBackgroundColor}
        jobadTagBackgroundColor={this.props.content.jobadTagBackgroundColor}
        linkTemplate={this.props.content.detailsLinkTemplate}
        isInEditMode={this.props.inEditor}
        key={listData[i].id}
        item={listData[i]}
      />);
    }
    return jobAds;
  }

  renderSnippet = (listData: ISingleJobadItemData[]) => {
    if (!this.props.content.detailsLinkTemplate || !listData || listData.length === 0) {
      return null;
    }

    const itemListData: (SchemaORG.Thing | SchemaORG.SchemaText)[] = listData
      .map((item, index) => ({
        '@type': 'ListItem',
        'position': index + 1,
        'url': joinUrl(this.props.state.configuration.CMSUrl,
          getLinkFinalURL(this.props.state, formLinkFromTemplate(this.props.content.detailsLinkTemplate, String(item.id)), item))
      }) as SchemaORG.Thing);

    return <Snippet.ItemList
      itemListElement={itemListData}
      id={`${this.props.state.currentFullPath}#carousel`}
    />;
  }

  get filterRegExp() {
    return new RegExp(`${regExpEscape(encodeURIComponent(this.props.id))}\\((.*)\\)`, 'g');
  }

  updateFilters = () => {
    let hash = this.props.history.location.hash || '#';
    const id = encodeURIComponent(this.props.id);
    const filterRegex = this.filterRegExp;
    const newFilter = `${id}(${encodeURIComponent(this.selectedCategoryTags.map(c => c.label).join(','))}:l:${encodeURIComponent(this.selectedLocationTags.map(l => l.label).join(','))})`;
    if (hash.match(filterRegex)) {
      hash = hash.replace(filterRegex, newFilter);
    } else {
      hash += newFilter;
    }

    this.props.dispatch.replacePage(this.props.history.location.pathname + hash);
  }

  @action
  toggleLocationTag = (tagText: string) => {
    const index = findIndex(this.selectedLocationTags, { label: tagText });
    if (index !== -1) {
      this.selectedLocationTags.splice(index, 1);
    } else {
      this.selectedLocationTags.push(createTagFromText(tagText));
    }
    this.fetchFilteredData();
    this.updateFilters();
  }

  @action
  toggleCategoryTag = (tagText: string) => {
    const index = findIndex(this.selectedCategoryTags, { label: tagText });
    if (index !== -1) {
      this.selectedCategoryTags.splice(index, 1);
    } else {
      this.selectedCategoryTags.push(createTagFromText(tagText));
    }

    this.fetchFilteredData();
    this.updateFilters();
  }

  @action
  removeAllButLastCategoryTags = () => {
    if (this.selectedCategoryTags.length > 0) {
      this.selectedCategoryTags.splice(0, this.selectedCategoryTags.length - 1);
    }
    this.fetchFilteredData();
  }

  onRemoveAllTags = () => {
    this.onRemoveAllCategoryTags();
    this.onRemoveAllLocationTags();
  }

  @action
  onRemoveAllCategoryTags = () => {
    if (this.selectedCategoryTags.length > 0) {
      this.selectedCategoryTags = [];
    }
    this.fetchFilteredData();
  }

  @action
  onRemoveAllLocationTags = () => {
    if (this.selectedLocationTags.length > 0) {
      this.selectedLocationTags = [];
    }
    this.fetchFilteredData();
  }

  @action
  removeAllButLastLocationTags = () => {
    if (this.selectedLocationTags.length > 0) {
      this.selectedLocationTags.splice(0, this.selectedLocationTags.length - 1);
    }
    this.fetchFilteredData();
  }

  getFiltersArray = (classNames: string[], selectedTags: ISelectedTag[], possibleTags: ISelectedTag[]) => {
    const filtersArray: IFilter[][] = [];
    if (selectedTags.length > 0) {
      filtersArray.push(classNames
        .map(property => ({
          propertyName: property,
          value: selectedTags.map(tag => ({
            filterValueType: FilterValueTypes.NORMAL,
            operator: possibleTags.indexOf(tag) !== -1 ? MentionFilterTypeEnum.Equals : MentionFilterTypeEnum.Contains,
            value: tag.label
          }))
        })));
    }
    return filtersArray;
  }
  @action fetchFilteredData = () => {
    const categoryFilters = this.getFiltersArray(
      CATEGORY_CLASS_NAMES, this.selectedCategoryTags, this.categories
    );
    const locationFilters = this.getFiltersArray(
      LOCATION_CLASS_NAMES, this.selectedLocationTags, this.locations
    );
    const newFilers: IFilterGroupsHolder = {...this.originalFilters, filterGroups: [...this.originalFilters.filterGroups, ...categoryFilters.map((filters) => ({filters})), ...locationFilters.map((filters) => ({filters}))]};
    this.props.dispatch.resolveLinkedData(
        [ this.props.content.selectedMention ],
        true,
        {
          filters: newFilers,
          pagedProperties: {page: 1},
          sortBy: this.props.content.jobadViewSort
        });
  }

  renderTag = (tagText: string, isMoreButton: boolean, tagList: TagListEnum, icon?: any) => {
    let tagColor = this.props.content.tagBackgroundColor;
    let selectedTags;
    if (tagList === TagListEnum.CATEGORY) {
      selectedTags = this.selectedCategoryTags;
    } else {
      selectedTags = this.selectedLocationTags;
    }
    const tagIndex = findIndex(selectedTags, { label: tagText });
    if (tagIndex !== -1) {
      tagColor = this.props.content.selectedTagBackgroundColor;
    }
    return <Tag
      backgroundColor={isMoreButton ? this.props.content.moreLessTagBackgroundColor : tagColor}
      onClick={action(() => {
        if (isMoreButton) {
          if (tagList === TagListEnum.ALL) {
            this.showAllCategoryTags = true;
            this.showAllLocationTags = true;
          } else if (tagList === TagListEnum.CATEGORY) {
            this.showAllCategoryTags = true;
          } else {
            this.showAllLocationTags = true;
          }
        } else if (tagList === TagListEnum.CATEGORY) {
          this.toggleCategoryTag(tagText);
        } else {
          this.toggleLocationTag(tagText);
        }
      })}
      key={tagText}
    >
      {icon}
      {tagText}
    </Tag>;
  }

  @action
  customSearchCategory = (searchTerm) => {
    this.selectedCategoryTags.push(createTagFromText(searchTerm));
    this.fetchFilteredData();
  }

  @action
  customSearchLocation = (searchTerm) => {
    this.selectedLocationTags.push(createTagFromText(searchTerm));
    this.fetchFilteredData();
  }

  @action
  updateContainerWidth = () => {
    let newWidth = this.props.state.windowSize.width || 300;
    if (this.tagsContainer) {
      newWidth = this.tagsContainer.getBoundingClientRect().width;
    }
    if (this.tagsContainerWidth !== newWidth) {
      this.tagsContainerWidth = newWidth;
    }
  }

  @action
  componentDidMount() {
    if (!this.mounted) {
      this.mounted = true;
    }
    if (!this.props.content.selectedMention) {
      return;
    }
    const linkedData = findLinkedData(this.props.content.selectedMention, this.props.state.activeDesign.data);
    if (!linkedData) {
      return;
    }
    this.originalFilters = Object.assign({}, toJS(linkedData.filters));
    if (this.props.history.location.hash) {
      const fullHashString = this.props.history.location.hash.slice(1);
      const foundHash = this.filterRegExp.exec(fullHashString);
      if (foundHash) {
        const hashString = foundHash[1];
        if (hashString.indexOf(':l:') !== -1) {
          const [category, location] = decodeURIComponent(hashString).split(':l:');
          this.selectedCategoryTags = category.split(',')
            .filter(c => !isStringEmpty(c))
            .map((c) => ({
              label: c,
              disabled: false
            }));
          this.selectedLocationTags = location.split(',')
            .filter(l => !isStringEmpty(l))
            .map((l) => ({
              label: l,
              disabled: false
            }));
          if (this.selectedCategoryTags.length > 0 || this.selectedLocationTags.length > 0) {
            this.fetchFilteredData();
          }
        }
      }
    }
    this.updateContainerWidth();
    this.metrics = textMetrics(ReactDOM.findDOMNode(this.tag));
    const foundData = findLinkedData(this.props.content.selectedMention, this.props.state.activeDesign.data);
    if (foundData) {
      this.props.service.pickerService.fetchPropertiesWithFilters(foundData.pickerResolver, ['JobAdModel.Category', 'JobAdModel.Municipality'], foundData.filters, this.props.state.activeDesign.page.id, this.props.state.activeDesign.loadParams.filterParameters).toPromise()
        .then(action((result: AjaxResponse) => {
          if (!result.response) {
            return;
          }
          this.categories = result.response['jobAdModel.Category'];
          this.locations = result.response['jobAdModel.Municipality'];
        }));
    }
  }

  componentDidUpdate() {
    this.updateContainerWidth();
  }

  @computed
  get shouldRenderShowMoreJobadsButton() {
    if (!this.props.content.selectedMention) {
      return false;
    }
    return this.linkedData && this.linkedData.pagedProperties && (this.linkedData.pagedProperties.page || 1) < this.linkedData.pagedProperties.totalPages;
  }

  renderTags = (tagListEnumEntry: TagListEnum) => {
    let totalTagsWidthEstimation = 0;
    let rows = 1;
    const tags = [];
    const tagWidths = [];
    if (tagListEnumEntry === TagListEnum.ALL) {
      const allTags: { label: string, listEnum: TagListEnum.LOCATION | TagListEnum.CATEGORY }[] = [...(this.categories.length > 1 ? this.categories.map((tagText) => ({
        label: tagText,
        listEnum: TagListEnum.CATEGORY
      })) : []), ...(this.locations.length > 1 ? this.locations.map((tagText) => ({
        label: tagText,
        listEnum: TagListEnum.LOCATION
      })) : [])].filter(entry => Boolean(entry.label) && entry.label !== '') as any;
      let rowRemainder = 0;
      let shouldInsertCategoryGroupLine = true;
      let shouldInsertLocationGroupLine = true;
      for (const entry of allTags) {
        const entryWidth = this.metrics.width(entry.label) + 2 * (TAG_HORIZONTAL_MARGIN + TAG_HORIZONTAL_PADDING);
        totalTagsWidthEstimation += entryWidth;
        if (totalTagsWidthEstimation > this.tagsContainerWidth) {
          rows++;
          rowRemainder = this.tagsContainerWidth - totalTagsWidthEstimation + entryWidth;
          totalTagsWidthEstimation = entryWidth;
        }

        if (tagListEnumEntry === TagListEnum.ALL && this.showAllCategoryTags) {
          const tag = this.renderTag(entry.label, false, entry.listEnum);
          tagWidths.push(entryWidth);
          if (shouldInsertCategoryGroupLine) {
            tags.push(<TagsGroupSeparator
              key="group_separator_c"
              backgroundColor={this.props.content.tagBackgroundColor}
            />);
            shouldInsertCategoryGroupLine = false;
          }
          if (entry.listEnum === TagListEnum.LOCATION && shouldInsertLocationGroupLine) {
            tags.push(<TagsGroupSeparator
              key="group_separator_l"
              backgroundColor={this.props.content.tagBackgroundColor}
            />);
            shouldInsertLocationGroupLine = false;
          }
          tags.push(tag);
        } else {
          const moreFilterText = draftToString(this.props.content.moreFiltersMessage, this.props.state);
          let neededWidth = this.metrics.width(moreFilterText) + 20 + 2 * (TAG_HORIZONTAL_MARGIN + TAG_HORIZONTAL_PADDING) - rowRemainder;
          while (neededWidth > 0) {
            neededWidth -= tagWidths.pop();
            tags.pop();
          }
          tags.push(this.renderTag(moreFilterText, true, tagListEnumEntry, <StyledPlus />));
          break;
        }
      }
    } else {
      const tagsToRender = (tagListEnumEntry === TagListEnum.CATEGORY ? this.categories : this.locations).filter(entry => Boolean(entry) && entry !== '');
      if (tagsToRender.length > 1) {
        let rowRemainder = 0;
        for (const entry of tagsToRender) {
          const entryWidth = this.metrics.width(entry) + 2 * (TAG_HORIZONTAL_MARGIN + TAG_HORIZONTAL_PADDING);
          totalTagsWidthEstimation += entryWidth;
          if (totalTagsWidthEstimation > this.tagsContainerWidth) {
            rows++;
            rowRemainder = this.tagsContainerWidth - totalTagsWidthEstimation + entryWidth;
            totalTagsWidthEstimation = entryWidth;
          }
          if ((tagListEnumEntry === TagListEnum.CATEGORY && this.showAllCategoryTags) || (tagListEnumEntry === TagListEnum.LOCATION && this.showAllLocationTags) || rows < 3) {
            const tag = this.renderTag(entry, false, tagListEnumEntry);
            tagWidths.push(entryWidth);
            tags.push(tag);
          } else {
            const moreFilterText = draftToString(this.props.content.moreFiltersMessage, this.props.state);
            let neededWidth = this.metrics.width(moreFilterText) + 20 + 2 * (TAG_HORIZONTAL_MARGIN + TAG_HORIZONTAL_PADDING) - rowRemainder;
            while (neededWidth > 0) {
              neededWidth -= tagWidths.pop();
              tags.pop();
            }
            tags.push(this.renderTag(moreFilterText, true, tagListEnumEntry, <StyledPlus />));
            break;
          }
        }
      }
    }

    const lessFiltersMessage = draftToString(this.props.content.lessFiltersMessage, this.props.state);
    if (this.showAllLocationTags && tagListEnumEntry === TagListEnum.LOCATION) {
      tags.push(<Tag
        backgroundColor={this.props.content.moreLessTagBackgroundColor}
        onClick={action(() => {
          this.showAllLocationTags = false;
        })}
        key={'Less filters'}
      >
        <StyledMinus />
        {lessFiltersMessage}
      </Tag>);
    } else if (this.showAllCategoryTags && (tagListEnumEntry === TagListEnum.CATEGORY || tagListEnumEntry === TagListEnum.ALL)) {
      tags.push(<Tag
        backgroundColor={this.props.content.moreLessTagBackgroundColor}
        onClick={action(() => {
          this.showAllCategoryTags = false;
          if (tagListEnumEntry === TagListEnum.ALL) {
            this.showAllLocationTags = false;
          }
        })}
        key={'Less filters'}
      >
        <StyledMinus />
        {lessFiltersMessage}
      </Tag>);
    }
    return tags;
  }

  @action
  onGeneralSearchTab = () => {
    this.selectedTagsTab = TagListEnum.CATEGORY;
  }

  @action
  onLocationSearchTab = () => {
    this.selectedTagsTab = TagListEnum.LOCATION;
  }

  renderSearchComponent = () => {
    const categorySearchTags = <TagSearch
      placeholder={draftToString(this.props.content.generalSearchText, this.props.state)}
      tagList={this.selectedCategoryTags}
      leftIcon={<StyledSearch color={this.props.content.tagBackgroundColor} />}
      tagBackgroundColor={this.props.content.tagBackgroundColor}
      onRemoveTag={this.toggleCategoryTag}
      onRemoveAllButLastTag={this.removeAllButLastCategoryTags}
      onRemoveAll={this.onRemoveAllCategoryTags}
      onSearch={this.customSearchCategory}
    />;

    const locationSearchTags = <TagSearch
      disableInput={this.locations.length === 1}
      placeholder={draftToString(this.props.content.locationSearchText, this.props.state)}
      tagList={this.selectedLocationTags}
      leftIcon={<StyledPin color={this.props.content.tagBackgroundColor} />}
      tagBackgroundColor={this.props.content.tagBackgroundColor}
      onRemoveTag={this.toggleLocationTag}
      onRemoveAllButLastTag={this.removeAllButLastLocationTags}
      onRemoveAll={this.onRemoveAllLocationTags}
      onSearch={this.customSearchLocation}
    />;
    let categoryTags;
    let locationTags;
    let allTags;
    if (this.shouldSplit) {
      categoryTags = this.renderTags(TagListEnum.CATEGORY);
      locationTags = this.renderTags(TagListEnum.LOCATION);
    } else {
      allTags = this.renderTags(TagListEnum.ALL);
    }
    return <SearchComponentWrapper>
      <SearchContainer>
        <>
          <AllTagsSearch>
            <TagSearch
              placeholder={draftToString(this.props.content.generalSearchText, this.props.state)}
              tagList={[...this.selectedCategoryTags, ...this.selectedLocationTags]}
              leftIcon={<StyledSearch color={this.props.content.tagBackgroundColor} />}
              tagBackgroundColor={this.props.content.tagBackgroundColor}
              onRemoveAll={this.onRemoveAllTags}
              onSearch={this.customSearchCategory}
            />
          </AllTagsSearch>
          <SplitTagsSearch>
            {categorySearchTags}
            <SearchSeparator backgroundColor={this.props.content.tagBackgroundColor} />
            {locationSearchTags}
          </SplitTagsSearch>
        </>
      </SearchContainer>
      <Tags>
        <Tag
          ref={(tag) => {
            this.tag = tag;
          }}
          backgroundColor="SecondaryTextColor"
          style={{
            position: 'absolute',
            display: 'inline-block',
            margin: 0,
            padding: 0,
            opacity: 0
          }}
        />
        <TagsWrapper>
          {this.shouldSplit ? <>
            <TagsContainer
              ref={(tagsContainer) => this.tagsContainer = ReactDOM.findDOMNode(tagsContainer)}
              shouldSplit={this.shouldSplit}
              shouldGrow={this.showAllCategoryTags || this.categories.length <= 1}
            >
              {categoryTags}
            </TagsContainer>
            <TagsContainer
              shouldSplit={this.shouldSplit}
              shouldGrow={this.showAllLocationTags || this.locations.length <= 1}
            >
              {locationTags}
            </TagsContainer>
          </> :
            <TagsContainer
              ref={(tagsContainer) => this.tagsContainer = ReactDOM.findDOMNode(tagsContainer)}
              shouldSplit={this.shouldSplit}
              shouldGrow={true}
            >
              {allTags}
            </TagsContainer>}
        </TagsWrapper>
      </Tags>
    </SearchComponentWrapper>;
  }

  @action
  onShowMoreJobadsButtonClick = () => {
    this.loadingMoreJobads = true;
    const categoryFilters = this.getFiltersArray(
      CATEGORY_CLASS_NAMES, this.selectedCategoryTags, this.categories
    );
    const locationFilters = this.getFiltersArray(
      LOCATION_CLASS_NAMES, this.selectedLocationTags, this.locations
    );
    const newFilers: IFilterGroupsHolder = {...this.originalFilters, filterGroups: [...this.originalFilters.filterGroups, ...categoryFilters.map((filters) => ({filters})), ...locationFilters.map((filters) => ({filters}))]};
    this.props.dispatch(resolveLinkedData(
        [ this.props.content.selectedMention ],
        false,
        {
          filters: newFilers,
          pagedProperties: {page: this.linkedData.pagedProperties.page + 1},
          sortBy: this.props.content.jobadViewSort
        }))
      .then(action(() => {
        this.loadingMoreJobads = false;
      }));
  }

  get showMoreJobadsButton() {
    if (this.loadingMoreJobads) {
      return <ShowMoreJobadsButtonWrapper>
        <CmsButton
          disabled={true}
          color={this.props.content.moreButton.backgroundColor}
          text={draftToString(this.props.content.loadingMessage, this.props.state)}
        />
      </ShowMoreJobadsButtonWrapper>;
    }
    if (this.shouldRenderShowMoreJobadsButton) {
      return <ShowMoreJobadsButtonWrapper>
        <CmsButton
          onClick={this.onShowMoreJobadsButtonClick}
          color={this.props.content.moreButton.backgroundColor}
          text={!isDraftEmpty(this.props.content.moreButton.text, this.props.state, []) && draftToString(this.props.content.moreButton.text, this.props.state, [])}
        />
      </ShowMoreJobadsButtonWrapper>;
    } else {
      return null;
    }
  }

  @computed
  get linkedData() {
    const selectedMention = this.props.content.selectedMention;
    if (!selectedMention) {
      return null;
    }
    const foundData = findLinkedData(selectedMention, this.props.state.activeDesign.data);
    if (isJobadData(foundData)) {
      return foundData as JobadListLinkedDataModel;
    } else {
      return null;
    }
  }

  render() {
    if (this.props.inEditor) {
      return <JobadListWrapper isCardLayout={this.props.content.jobadViewStyle === JobadViewStyleEnum.CARD}>
        {!this.props.content.selectedMention ?
          <Translate>jobad-list.edit.placeholder</Translate> : this.renderJobadList([{
            pubDateTo: moment().format('YYYY-MM-DD'),
            pubDateFrom: moment().format('YYYY-MM-DD'),
            category: 'Cars',
            companyLogoUrl: 'https://getuikit.com/v2/docs/images/placeholder_200x100.svg',
            companyName: 'Example Company',
            company: 'Example Company',
            contacts: [],
            country: 'Sweden',
            municipality: 'Stockholm',
            countryId: '1',
            id: 1,
            municipalityId: '1',
            position: 'Business Analytics',
            jobPositionTitle: 'Business Analytics',
            positionCategory: 'Management',
            positionCategoryId: '1',
            positionId: '1',
            state: 'Stockholm',
            stateId: '1',
            title: 'Example Job Ad'
          }])}
      </JobadListWrapper>;
    }
    if (!this.linkedData) {
      return null;
    }
    const listData = this.linkedData.data;
    return <JobadListWrapper isCardLayout={this.props.content.jobadViewStyle === JobadViewStyleEnum.CARD}>
      {!isDraftEmpty(this.props.content.headerText, this.props.state, []) &&
        <HeaderTextWrapper><DraftToHtml
          draft={this.props.content.headerText}
          inEditor={this.props.inEditor}
        /></HeaderTextWrapper>}
      {this.props.content.showFilter && this.renderSearchComponent()}
      {this.renderJobadList(listData)}
      {this.linkedData.error && this.linkedData.error.errorCode === LinkedDataErrorCodes.FetchDataError ? <ErrorWrapper>
        {draftToString(this.props.content.fetchErrorMessage, this.props.state)}
      </ErrorWrapper> : undefined}
      {this.renderSnippet(listData)}
      {this.showMoreJobadsButton}
    </JobadListWrapper>;
  }
}
